import React from 'react';
import PropTypes from 'prop-types';
import { Link } from '@houzz/ui';

const Github = ({ link }) => {
    return (
        <Link href={link} target="_blank" rel="noopener">
            View on Github
        </Link>
    );
};

Github.propTypes = {
    link: PropTypes.string,
};
export default Github;
